import React, { useState } from 'react';
import "./HelpSendBox.css";
import { Avatar } from "@material-ui/core";
import firebase from "firebase";
import { db } from "../firebase";

function HelpSendBox() {
    const user = firebase.auth().currentUser;
    const [question, setQuestion] = useState("");

    const submitIssue = (e) => {
        e.preventDefault();
        db.collection("help").add({
            photoURL: user?.photoURL,
            displayName: user?.displayName,
            question: question,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
        setQuestion("");
    }

    return (
        <center>
        <div className="helpSendBox">
            <div className="helpBox__top">
                <Avatar src={user?.photoURL} />
                <input placeholder="Enter the problem you are facing while using TiTaniht and let the world answer it." value={question} onChange={(e) => setQuestion(e.target.value)} required/>
            </div>
            <div className="helpBox__postButton">
                <button disable={!question} onClick={submitIssue}>Post your issue</button>
            </div>
            
        </div>
        </center>
    )
}

export default HelpSendBox;